export class Profile {
  id: number;
  timeZone: string;

  constructor() {
    this.id = undefined;
    this.timeZone = '';
  }
}
